import * as React from 'react';
import { Anchor, Sticky, Styler, TypographyBody } from '@honeycomb/ui-core';
import { BackgroundColor } from '@honeycomb/data';
import { useResolveCMSColors } from './utils';
const validBackgroundColors = new Set(Object.values(BackgroundColor));
// This is a type safety hack. I wanted to add a backgroundColor2 property to the schema with type "backgroundColor",
// but it does not get mapped.
function toBackgroundColor(value) {
    return validBackgroundColors.has(value)
        ? value
        : undefined;
}
export function PromoBar({ promoBarItem }) {
    const { backgroundColor: backgroundColorCMS, textColor: textColorCMS, linkUrl, message, isSticky } = promoBarItem;
    const { backgroundColor, textColor } = useResolveCMSColors({
        backgroundColorCMS: toBackgroundColor(backgroundColorCMS) || undefined,
        textColorCMS: textColorCMS || undefined,
    });
    return (React.createElement(Sticky, { disabled: !isSticky },
        React.createElement(Styler, { align: "center", bg: backgroundColor, py: 2 }, linkUrl ? (React.createElement(Anchor, { href: linkUrl, color: textColor, weight: "semiBold", target: "_new" }, message)) : (React.createElement(TypographyBody, { color: textColor, weight: "semiBold", size: "s" }, message)))));
}
